<template>
  <div class="menu_item" @click="movePage()">
    <img :src="`${image}?v=1`">
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },

  methods: {
    movePage() {
      if (this.url.startsWith('http')) {
        window.open(this.url, '_blank').focus();
      } else {
        this.$router.push(this.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  font-size: 12px;
  cursor: pointer;
  img {
    width: 50px;
    @media screen and  (max-width: $tabletWidth) {
      width: 30px;
    }
  }
  span {
    line-height: 8px;
    font-size: 14px;
    font-weight: bold;
    @media screen and  (max-width: $tabletWidth) {
      font-size: 12px;
    }
  }
}
</style>
